import {
  DesignChangeMap,
  DesignChangeMapSettings,
  DesignChangeMapSettingsGlobalLoopHandling,
  DesignChangeMapSettingsIntentHandling,
  DesignCompoundIntent
} from '../../../../types';

/** Keys that should not appear in changeset views. */
type KeysToExclude = (
  'author'
  | 'createdTime'
  | 'id'
  | 'lastLocalChange'
  | 'lastSavedChange'
);

export const designChangeMapLabel: Record<keyof(DesignChangeMap), string> = {
  appProperties: 'Application Properties',
  'application-modules': 'Application Modules',
  'application-objects': 'Application Objects',
  'application-intents': 'Application Intents',
  'application-variables': 'Application Variables',
  applicationVersion: 'Application Version',
  ccxml: 'CCXML',
  compoundIntents: 'Compound Intents',
  csvData: 'CSV Data (Tabular Data)',
  fillerPrompts: 'Filler Prompts',
  folders: 'Module Folders',
  functions: 'Functions',
  globalIntents: 'Global Intents',
  graphQLSchemas: 'GraphQLSchemas',
  intentHandling: 'Intent Handling',
  languages: 'Languages',
  modules: 'Modules',
  settings: 'Settings',
  unitTests: 'Unit Tests'
};

export const designChangeMapSettingsLabels: Record<(
  keyof(DesignChangeMapSettings)
), (
  string
)> = {
  description: 'Description',
  dtmf_live_agent_override_pattern: 'Live Agent DTMF Override',
  globalErrorHandling: 'Global Error Handling',
  globalExceptionHandling: 'Global Exception Handling',
  globalLoopHandling: 'Global Loop Handling',
  intentHandling: 'Intent Handling',
  noInputTimeout: 'No Input Timeout Override',
  omniChannel: 'Omni Channel',
  rootSettings: 'Root Settings',
  sensitiveOverrides: 'Sensitive Overrides'
};

export const designChangeMapSettingsGlobalLoopHandlingLabels: Record<(
  keyof(DesignChangeMapSettingsGlobalLoopHandling)
), (
  string
)> = {
  inARow: 'Global Loop Handling: In A Row',
  xAndOut: 'Global Loop Handling: X And Out'
};

export const designChangeMapSettingsIntentHandlingLabels: Record<(
  keyof(DesignChangeMapSettingsIntentHandling)
), (
  string
)> = {
  inARowLimit: 'Intent Handling: In A Row Limit',
  xAndOutLimit: 'Intent Handling: X And Out Limit'
};

export const designCompoundIntentLabels: Record<(
  Exclude<keyof(DesignCompoundIntent), KeysToExclude>
), (
  string
)> = {
  fromIntent1: 'From Intent 1',
  fromIntent2: 'From Intent 2',
  toIntent: 'To Intent'
};

/** Labels for @see ChangeItemChangesetWithItems. */
export const changesetItemsLabels: Record<string, string> = {
  arguments: 'Argument',
  inputs: 'Input',
  localVariables: 'Local Variable',
  nodes: 'Node',
  outputs: 'Output'
};
